import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const SlideQuestionRenderer = ({
  slide,
  currentSlide,
  answerState,
  onAnswerChange,
  submittedAnswers,
  handleSubmitAnswer,
  canSubmitAnswer,
  elementIds = {},
}) => {
  if (!slide) return null;

  const isMultiple = slide.type === "multiple";
  const isPoll = slide.type === "poll";
  const isText = slide.type === "text";
  const { questionId, choiceIdByIndex = {} } = elementIds;

  const isSelected = (choiceId) =>
    isMultiple
      ? (answerState?.multipleOptions || []).includes(choiceId)
      : answerState?.pollOption === choiceId;

  const handleOptionChange = (choiceId) => {
    if (isMultiple) {
      const current = answerState?.multipleOptions || [];
      onAnswerChange({
        multipleOptions: current.includes(choiceId)
          ? current.filter((id) => id !== choiceId)
          : [...current, choiceId],
      });
    } else {
      onAnswerChange({ pollOption: choiceId });
    }
  };

  return (
    <>
      {isText && (
        <div className="h-[calc(100vh-6rem)] flex flex-col justify-center items-start rounded-lg p-8 md:pl-10 bg-gray-100">
          <h4 className="text-[4vw] lg:text-[2vw] mb-5 font-semibold">
            Text Question
          </h4>
          <p
            id={questionId ? `canvas-el-${questionId}` : undefined}
            className="text-gray-700 text-[3vw] lg:text-[2vw] font-medium"
          >
            {slide.question}
          </p>
          <textarea
            value={answerState?.text || ""}
            onChange={(e) => onAnswerChange({ text: e.target.value })}
            placeholder="Enter your answer here..."
            className="mt-6 w-full p-3 border rounded-lg focus:ring-2 focus:ring-lightPurple text-gray-700"
            rows={6}
          />
          <button
            onClick={handleSubmitAnswer}
            disabled={!canSubmitAnswer()}
            className="mt-8 px-8 py-3 bg-lightPurple text-white rounded-lg font-bold disabled:opacity-50 hover:bg-purple-700 transition"
          >
            {submittedAnswers.has(currentSlide) ? "Answer Submitted" : "Submit Answer"}
          </button>
        </div>
      )}

      {(isPoll || isMultiple) && (
        <div className="h-[calc(100vh-6rem)] w-full flex flex-col justify-center items-start rounded-lg p-5 md:p-8 md:pl-10 bg-gray-100">
          <p
            id={questionId ? `canvas-el-${questionId}` : undefined}
            className="text-gray-700 text-[3.5vw] lg:text-[2vw] font-medium"
          >
            {slide.question}
          </p>

          <div className="mt-5 space-y-3">
            {slide.options?.map((choice, index) => (
              <label
                key={index}
                id={choiceIdByIndex[index] ? `canvas-el-${choiceIdByIndex[index]}` : undefined}
                className="flex items-center space-x-3 text-gray-700 text-[3vw] lg:text-[1.5vw] cursor-pointer px-3 py-2 rounded-lg border-2 border-gray-300 hover:border-gray-400 transition"
                onClick={() => handleOptionChange(choice.id)}
              >
                <span
                  className={`flex items-center justify-center shrink-0
                    h-[3vw] w-[3vw] lg:h-[1.5vw] lg:w-[1.5vw]
                    border transition
                    ${isMultiple ? "rounded-md" : "rounded-full"}
                    ${isSelected(choice.id) ? "bg-green-500 border-green-500" : "border-gray-400"}`}
                >
                  {isSelected(choice.id) && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-white text-[2vw] lg:text-[1vw]"
                    />
                  )}
                </span>
                <span className="px-[0.5vw] w-[70vw] lg:w-auto">
                  {choice.choice_text}
                </span>
              </label>
            ))}
          </div>

          <button
            onClick={handleSubmitAnswer}
            disabled={!canSubmitAnswer()}
            className="mt-8 px-8 py-3 bg-lightPurple text-white rounded-lg font-bold disabled:opacity-50 hover:bg-purple-700 transition"
          >
            {submittedAnswers.has(currentSlide) ? "Answer Submitted" : "Submit Answer"}
          </button>
        </div>
      )}
    </>
  );
};

export default SlideQuestionRenderer;
